import { useState, useCallback } from "react";

const LAM_TOKEN_KEY = "adminEatzyToken";

export function useLAMToken() {
  const [token, setTokenState] = useState<string | null>(() =>
    sessionStorage.getItem(LAM_TOKEN_KEY)
  );

  const setToken = useCallback((newToken: string) => {
    sessionStorage.setItem(LAM_TOKEN_KEY, newToken);
    setTokenState(newToken);
  }, []);

  const clearToken = useCallback(() => {
    sessionStorage.removeItem(LAM_TOKEN_KEY);
    setTokenState(null);
  }, []);

  return {
    token,
    isAuthenticated: !!token,
    setToken,
    clearToken,
  };
}
